<template>
  <div>
    <el-dialog
      title="选择项目"
      :visible.sync="visible"
      :close-on-click-modal="false"
      width="1000px"
      class="ecology-report-select-project"
    >
      <div class="content">
        <Search ref="search" :searchConfig="searchConfig" @doSearch="doSearch">
        </Search>
        <Table
          ref="table"
          class="table"
          :tableConfig="tableConfig"
          @checked="onChecked"
        >
        </Table>
      </div>
      <div :slot="'footer'">
        <el-button @click="onClose" size="small">关 闭</el-button>
        <el-button @click="onConfirm" type="primary" size="small"
          >确 认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Table from "./table.vue";
import Search from "./search.vue";
export default {
  components: {
    Table,
    Search,
  },
  data() {
    return {
      visible: false,
      searchConfig: {
        params: [
          {
            prop: "projectName",
            label: "项目名称",
          },
          {
            prop: "tableno",
            label: "申请单号",
            placeholder: "模糊搜索",
          },
        ],
      },
      tableConfig: {
        searchUrl: "/front/oms/sso/supplier/order/bpmProjectList", // 搜索接口
        searchMethod: "POST", // 接口请求方式
        needPagination: true, // 是否需要分页
        fluidHeight: true, // 流体高度
        showOrdinal: false, // 是否显示序号,
        radioInfo: {
          key: "id",
          label: "",
          width: "",
        },
        resultListName: "dataList",
        params: [
          {
            prop: "tableno",
            label: "单号",
          },
          {
            prop: "projectname",
            label: "项目名称",
          },
          {
            prop: "projectmanage",
            label: "项目经理",
          },
          {
            prop: "devicename",
            label: "装置名称",
          },
          {
            prop: "useStartTime",
            label: "预计开始时间",
          },
          {
            prop: "useEndTime",
            label: "预计结束时间",
          },
        ],
        extra: {},
      },
      row: null,
    };
  },
  methods: {
    onChecked({ row }) {
      console.log(row);
      this.row = row;
    },
    onShow() {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.table.getList();
      });
    },
    doSearch(params) {
      this.tableConfig.extra = { ...params };
      this.$refs.table.getList();
    },
    onConfirm() {
      if (!this.row) {
        this.$message.warning("请选择项目");
        return;
      }
      this.$emit("confirm", this.row);
      this.onClose();
    },
    onClose() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  height: 540px;
}
</style>
<style lang="scss">
.ecology-report-select-project {
  .el-dialog__title {
    font-family: Alibaba PuHuiTi;
    font-size: 20px;
    font-weight: 600;
    color: #1a1a1a;
  }

  .el-icon-close {
    color: #333;
    font-weight: 600;
  }

  .el-dialog__body {
    padding: 10px 20px;
  }
}
</style>
